/**
 * DTO for Customer response from backend.
 */
export class CustomerResponse {
  constructor(
    id,
    name,
    email,
    phone,
    address,
    petCount,
    createdAt,
    updatedAt
  ) {
    this.id = id;
    this.name = name;
    this.email = email;
    this.phone = phone;
    this.address = address;
    this.petCount = petCount;
    this.createdAt = createdAt;
    this.updatedAt = updatedAt;
  }

  /**
   * Create CustomerResponse from JSON object.
   */
  static fromJSON(json) {
    return new CustomerResponse(
      json.id,
      json.name,
      json.email,
      json.phone,
      json.address,
      json.petCount,
      json.createdAt,
      json.updatedAt
    );
  }
}
